import type { Network, NetworkOption } from './types'

export const NETWORK_RENEC: Network = 'RENEC Network'
export const renecNetworkOption: NetworkOption = {
  chain_name: NETWORK_RENEC,
  chain_name_abbr: NETWORK_RENEC,
}

// to be fetched from API in the future
// Note: RENEC should be first of the list
export const networkOptions = [renecNetworkOption]
